import React from "react";

export default function Testimonials({ eyebrow, title, subtitle, items = [] }) {
  if (!items.length) return null;

  return (
    <section className="eb-section bg-slate-50/60">
      <div className="eb-container">
        <div className="max-w-2xl">
          {eyebrow ? <div className="eb-pill">{eyebrow}</div> : null}
          <h2 className="mt-4 eb-h2">{title}</h2>
          {subtitle ? <p className="mt-4 text-lg eb-muted">{subtitle}</p> : null}
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, idx) => (
            <figure key={`${t.name}-${idx}`} className="eb-card p-6">
              <blockquote className="text-slate-700">
                <p className="text-sm leading-6">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-5 flex items-center justify-between gap-4">
                <div>
                  <div className="text-sm font-semibold text-slate-900">{t.name}</div>
                  {t.role ? <div className="text-sm text-slate-600">{t.role}</div> : null}
                </div>
                {t.company ? <div className="text-xs font-semibold text-slate-500">{t.company}</div> : null}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

